import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageNWSL2 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "Trinity Rodman Returns",
            author: "footballgirl",
              date: "January, 2026",
            image: "images/nwsl/2a.jpg",
            content: `<h2>Trinity Rodman Returns to USWNT Roster for January Camp and Friendlies</h2>


<p><b>Forward Trinity Rodman</b> has been named to the United States Women's National Team (USWNT) roster for the January 2026 training camp and international friendlies, marking her return to the squad after an extended absence.</p>

<p>USWNT head coach Emma Hayes announced a 26-player roster on January 8, 2026, for the camp held in Southern California at Dignity Health Sports Park. The team featured two friendlies: against Paraguay on January 24 and Chile on January 27. Rodman, listed as unattached (out of contract with her club at the time of the announcement), was a standout inclusion. She had not featured for the USWNT since April 2025, with injuries—including an MCL sprain that impacted her NWSL postseason play—limiting her international appearances in 2025 to just one match (a 2-0 win over Brazil where she scored).</p>

<h2>Youth-Oriented Roster Composition</h2>
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>
<p>The roster was notably youth-oriented and drawn almost entirely from NWSL players, with Rodman as the exception due to her contract status. It included four first-time call-ups and a mix of emerging talents alongside more experienced players. Rodman entered the camp as the most capped player on the roster with 47 caps and 11 goals, in a group where the average was around 6.3 caps per player.</p>

<h2>Significance of the January Window</h2>
<p>The January window served as the USWNT's first international activity of 2026, providing opportunities to evaluate players and set the tone for the year ahead under Hayes' leadership. Rodman's return was widely highlighted as a positive development, especially given her status as a key attacking talent.</p>

<h2>Rodman's Contract Extension and On-Field Impact</h2>
<p>During the camp, Rodman performed prominently. Ahead of the matches, she signed a landmark three-year contract extension with the Washington Spirit, reportedly making her the highest-paid women's soccer player in the world at the time. This deal resolved months of speculation about her club future, whether staying in the NWSL or moving to Europe.</p>

<p>Rodman captained the team for the first time—wearing the armband against Paraguay—demonstrating her leadership and elevated role in the squad. The USWNT delivered strong performances in the friendlies, with Rodman central to the team's success in convincing victories: a 6-0 rout of Paraguay (where she scored) and a 5-0 win over Chile (where she also scored).</p>

<h2>Blending Experience and Youth</h2>
<p>The camp blended veteran presence with fresh faces, allowing Hayes to test combinations and give responsibilities to players like Rodman amid the absence of some regular starters such as Naomi Girma, Rose Lavelle, and Emily Sonnett.</p>

<h2>Conclusion</h2>
<p>Rodman's inclusion and contributions underscored her importance to the program as the USWNT builds toward future competitions.</p><h1>特里尼蒂·罗德曼重返美国女足国家队一月训练营及友谊赛阵容</h1>
<h2>Trinity Rodman Returns to USWNT Roster for January Camp and Friendlies</h2>

<h2>引言与阵容公布</h2>
<p><b>前锋特里尼蒂·罗德曼（Trinity Rodman）</b>已被列入美国女子国家足球队（USWNT）2026年1月训练营及国际友谊赛阵容，这标志着她在长时间缺席后重返球队。</p>

<p>美国女足主教练埃玛·海耶斯（Emma Hayes）于2026年1月8日公布了26人阵容，该训练营在南加州尊严健康体育公园（Dignity Health Sports Park）举行。球队将进行两场友谊赛：1月24日对阵巴拉圭，1月27日对阵智利。罗德曼当时因与俱乐部合同到期而被列为“无所属”（unattached），成为阵容中的亮点。她自2025年4月以来未曾为美国女足出场，2025年因伤病（包括影响NWSL季后赛的膝盖内侧副韧带扭伤）仅参加了一场国际比赛（2-0战胜巴西，她在该场比赛中进球）。</p>

<h2>以年轻球员为主的阵容构成</h2>
<p>这支阵容明显偏向年轻化，几乎全部来自NWSL球员，罗德曼因合同状况成为例外。阵容包括四名首次入选的球员，以及新兴天才与经验球员的混合。罗德曼以47次出场和11粒进球成为阵容中出场次数最多的球员，而整支球队平均出场次数约为6.3次。</p>

<h2>一月国际比赛窗口的意义</h2>
<p>一月窗口是美国女足2026年的首次国际活动，为海耶斯提供了评估球员并为未来一年定调的机会。罗德曼的回归被广泛视为积极进展，特别是考虑到她作为关键进攻球员的地位。</p>

<h2>罗德曼的合同续约及其场上表现</h2>
<p>在训练营期间，罗德曼表现出色。在比赛前，她与华盛顿精神队签订了一份具有里程碑意义的三年合同续约，据报道使她成为当时世界上薪资最高的女足球员（年薪超过200万美元，包括奖金）。这份合同结束了数月来关于她俱乐部未来的猜测——是留在NWSL还是转会欧洲。</p>

<p>罗德曼首次担任球队队长——在对阵巴拉圭的比赛中佩戴队长袖标——展现了她的领导力和在队中的提升角色。美国女足在友谊赛中表现出色，罗德曼成为球队取得令人信服胜利的核心：1月24日6-0大胜巴拉圭（她在第56分钟进球），1月27日5-0战胜智利（她在第68分钟进球，并在进球后与主教练海耶斯共舞庆祝）。</p>

<h2>经验与青春的融合</h2>
<p>训练营将老将与新人相结合，让海耶斯有机会测试不同组合，并在娜奥米·吉尔玛（Naomi Girma）、罗斯·拉维尔（Rose Lavelle）和艾米莉·索内特（Emily Sonnett）等常规主力缺席的情况下，给像罗德曼这样的球员更多责任。</p>

<h2>结语</h2>
<p>罗德曼的入选及其贡献凸显了她在美国女足项目中的重要性，随着球队向未来赛事迈进。</p>`,
            tags: ["USWNT", "Trinity Rodman", "NWSL", "Washington Spirit"],
            navIndices: { prev: 'nwsl-1', next: 'nwsl-3' }
        });
    }

    init() {
        console.log('ArticlePageNWSL2 initialized');
        super.init();
    }

    render() {
        super.render();
        
        // Update Back Button Text and Behavior
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to NWSL
            `;
            
            // Replace with clone to remove old event listener (which went to top of page)
            // and attach new one that goes to #nwsl anchor
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'nwsl' } });
                this.element.dispatchEvent(event);
            });
        }

        // Update League Logo in the corner
        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) {
            leagueLogo.src = '/images/league_nwsl.png';
            leagueLogo.alt = 'NWSL';
        }
    }
}